import React from 'react';
import styled from 'styled-components';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { visualizarReporteEnPdf,generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';
import { formatearNumeroEntero } from '../../funciones_globales/format';
import { cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import { getFechaProcesoPorModulo,getItemDatosSesion} from '../../funciones_globales/manejosesion';
import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';


const COD_BOTON_EXCEL = '080101';
const LabelSub = styled.label`
    font-weight: 200;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

const Radio = styled.input`
    font-weight: 600;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

class FormCon05  extends React.Component{
    constructor(props){
        super(props);
        this.state = {            
            periodo: '',
            mes_sel: null,
            mes_opt: [],
            anioActual: null,
            opcRepo: 'F',
            saldoIndMes: false,
            isVisibleBotonExcel:false
        };
        
        this.changeComponents = this.changeComponents.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.imprimirEstadosFinancieros = this.imprimirEstadosFinancieros.bind(this);    
        this.imprimirEstadosFinancierosExcel = this.imprimirEstadosFinancierosExcel.bind(this);    
    }
    
    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    changeYear(){
        if(this.state.periodo!==''){
            let anio = formatearNumeroEntero(this.state.periodo);
            let fechaInf = formatearNumeroEntero(this.state.anioActual) - 3;

            if(anio>formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: formatearNumeroEntero(this.state.anioActual)});
            }else if(anio===formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: anio});
            }else if(anio >= fechaInf && anio <=formatearNumeroEntero(this.state.anioActual)){
                this.setState({periodo: anio});
            }else{
                this.setState({periodo: formatearNumeroEntero(this.state.anioActual)});
                alert("Sólo puede consultar información de los últimos 3 años.");
            }
        }
    }
    
    componentDidMount(){
        let usuario = getItemDatosSesion('usuario');
        Promise.all([
            cargarCatalogos_Otros('MESES'),
            cargarPermisoBoton(COD_BOTON_EXCEL, usuario),
            this.props.generar_LogAuditoriaIngresoForm('0805')
         ])
        .then(([ meses,configBotonExcel ]) => {
            let isVisibleBotonExcel = false;

            if(configBotonExcel.display==='block'){
                isVisibleBotonExcel = true;
            }

            let fechaProceso = getFechaProcesoPorModulo('08');
            let anioActual = fechaProceso.toString().split("/")[2];
            let mesActual = fechaProceso.toString().split("/")[1];
                
            this.setState({ mes_opt: meses, anioActual: formatearNumeroEntero(anioActual),
                            periodo: formatearNumeroEntero(anioActual), mes_sel: mesActual,   isVisibleBotonExcel });
            
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0805');
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('08');
        this.setState({
            opcRepo: 'F',
            periodo: fechaProceso.toString().split("/")[2],
            mes_sel: fechaProceso.toString().split("/")[1],
            anioActual: fechaProceso.toString().split("/")[2],
            saldoIndMes: false
        })
    }

    imprimirEstadosFinancieros(){
        var idRpt = null;
        if(this.state.opcRepo==='F'){
            idRpt = 41;
        }else{
            if(this.state.opcRepo==='I'){
                idRpt = 42;
            } else{
                if(this.state.opcRepo==='C'){
                    idRpt = 170;
                    }else{
                        idRpt = 97;
                }
            }
        }
      
        let rptUrlWithParams = `&rpt=${idRpt}&param1=${this.state.periodo}&param2=${this.state.mes_sel}`;

        if(this.state.saldoIndMes){
            rptUrlWithParams+=`&param3=N`;
        }
        
        visualizarReporteEnPdf(rptUrlWithParams);
    }
    imprimirEstadosFinancierosExcel(){
        var idRpt = null;
        if(this.state.opcRepo==='F'){
            idRpt = 129;
        }else{
            if(this.state.opcRepo==='I'){
                idRpt = 130;
            }else{
                idRpt = 131;
            }
        }
      
        let rptUrlWithParams = `&rpt=${idRpt}&param1=${this.state.periodo}&param2=${this.state.mes_sel}`;

        if(this.state.saldoIndMes){
            rptUrlWithParams+=`&param3=N`;
        }
        
        generarReporteEnExcel(rptUrlWithParams);
    }
    render(){
        return (
            <ContenedorForm porc_ancho={60}>
                <HeaderForm>
                    <TituloForm>Estados Financieros</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                <Row margen_arriba={20}>
                    <ContainerCol className='col-sm-12'>
                        <LabelSub><Radio name='opcRepo' type='radio' disabled={false} value='F' onChange={this.changeComponents} checked={this.state.opcRepo==='F'?true:false}/>{' Situación Financiera'}</LabelSub>
                        <LabelSub><Radio name='opcRepo' type='radio' disabled={false} value='I' onChange={this.changeComponents} checked={this.state.opcRepo==='I'?true:false}/>{' Resultados Integral'}</LabelSub>
                        <LabelSub><Radio name='opcRepo' type='radio' disabled={false} value='O' onChange={this.changeComponents} checked={this.state.opcRepo==='O'?true:false}/>{' Cuentas de Orden'}</LabelSub>
                        <LabelSub><Radio name='opcRepo' type='radio' disabled={false} value='C' onChange={this.changeComponents} checked={this.state.opcRepo==='C'?true:false}/>{' Balance Comprobacion'}</LabelSub>
                    </ContainerCol>
                </Row>
                <Row margen_arriba={10}>
                    <ContainerCol className='col-sm-2'>
                        <LabelForm>Periodo:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                        <InputText name='periodo' value={this.state.periodo} type="number" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.changeYear(value)}}/>
                    </ContainerCol>
                </Row>
                <Row margen_arriba={10}>
                    <ContainerCol className='col-sm-2'>
                        <LabelForm>Mes:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-3'>
                        <ReactSelect options={ this.state.mes_opt } value={this.state.mes_sel} func_onChange={(value)=>{this.setState({mes_sel: value!==null?value.value:null})}}/>
                    </ContainerCol>
                    <ContainerCol className='col-sm-3'>
                        <LabelForm>Saldos Independientes por Mes:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-1'>
                        <LabelForm><input type='checkbox' name='saldoIndMes' checked={this.state.saldoIndMes} onChange={this.changeComponents}/></LabelForm> 
                    </ContainerCol>
                </Row>
                <Row margen_arriba={20}>
                    <ContainerCol className='col-sm-12'>
                        <div className='btn-group pull-right'>
                            <button type='button' className='btn btn-info btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={()=>{this.imprimirEstadosFinancieros('PDF')}}><i className='fa fa-print fa-lg' aria-hidden='true'/> Imprimir</button>
                            {
                                this.state.isVisibleBotonExcel?
                                <button type='button' className='btn btn-success btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={()=>{this.imprimirEstadosFinancierosExcel()}}><i className='fa fa-print fa-lg' aria-hidden='true'/> Imprimir EXCEL</button>    
                                :null
                            }
                           
                            <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                        </div>
                    </ContainerCol>
                </Row>
            </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});
  
export default connect (null, mapDispatchToProps)(FormCon05);